import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';

EDC.Games.IdentifyGridPositions.Scenes.Main = function () {
  BaseMinigamesMain.apply(this, [EDC.Games.IdentifyGridPositions, 59]);
  this.gameConfig = store.getters['games/getGameById']().sets[0].config;
  this.gameData = EDC.Games.IdentifyGridPositions.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.candy = null;
  this.choices = [];
};

EDC.Games.IdentifyGridPositions.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
// eslint-disable-next-line max-len
EDC.Games.IdentifyGridPositions.Scenes.Main.prototype.constructor = EDC.Games.IdentifyGridPositions.Scenes.Main;

const IGP = EDC.Games.IdentifyGridPositions.Scenes.Main.prototype;

IGP.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

IGP.loadIteration = function () {
  this.addCandy();
  this.creatChoices();
};

IGP.createTemplateUI = function () {
  this.add.sprite(310, 410, 'title');
  this.add.sprite(1630, 430, 'instructions');
  this.add.sprite(970, 410, 'grid');
};

IGP.addCandy = function () {
  const randomCandy = Math.round(Math.random() * 8);
  const coordinates = this.getCandyPosition();
  const candy = this.add.sprite(coordinates.x, coordinates.y, `candy-${randomCandy}`).setOrigin(0.5);
  this.spriteAnimation(candy);
  this.candy = candy;
};

IGP.getCandyPosition = function () {
  const { position } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const positions = {
    0: { x: 960, y: 407 },
    1: { x: 717, y: 407 },
    2: { x: 1212, y: 407 },
    3: { x: 960, y: 164 },
    4: { x: 960, y: 655 },
    5: { x: 1212, y: 164 },
    6: { x: 717, y: 164 },
    7: { x: 1212, y: 655 },
    8: { x: 717, y: 655 },
  };
  return positions[position];
};

IGP.creatChoices = function () {
  const randomChoices = this.generateRandomChoices();
  const { position } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  for (let i = 0; i < 4; i++) {
    const container = this.createLabel(randomChoices[i]);
    container.setPosition(400 + i * 370, 900);
    if (randomChoices[i] === position) {
      container.isCorrect = true;
    } else {
      container.isCorrect = false;
    }
    this.startShakeAnimation(container);
    container.setInteractive();
    const markAnim = new AnswerMark(this, container).setScale(0.45);
    container.setData('markAnim', markAnim);
    this.cursorManager.setDefaultDraggableEvents(container);
    container.on('pointerup', this.checkAnswer.bind(this, container), this);
    this.choices.push(container);
  }
};

IGP.createLabel = function (index) {
  const labels = {
    0: ['middle'],
    1: ['left'],
    2: ['right'],
    3: ['top'],
    4: ['bottom'],
    5: ['top', 'right'],
    6: ['top', 'left'],
    7: ['bottom', 'right'],
    8: ['bottom', 'left'],
  };
  const container = this.add.container(0, 0);
  const button = this.add.sprite(0, 0, 'button').setScale(0.75);
  container.setSize(button.displayWidth, button.displayHeight);
  container.add(button);
  // display the labels
  const label = labels[index];
  if (label.length > 1) {
    const label1 = this.add.sprite(0, -30, label[0]).setScale(0.8);
    const label2 = this.add.sprite(0, 35, label[1]).setScale(0.8);
    container.add(label1);
    container.add(label2);
  } else {
    const label1 = this.add.sprite(0, 0, label[0]).setScale(0.8);
    container.add(label1);
  }

  return container;
};

IGP.generateRandomChoices = function () {
  const { position } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  // create array of 4 choices which contains correct
  // answer plus 3 random other choices then shuffle.
  let randomChoices = [];
  for (let i = 0; i < 9; i++) {
    if (position === i) {
      randomChoices.push(i);
    }
  }
  for (let i = 0; i < 4; i++) {
    if (position !== i) {
      if (randomChoices.length < 4) {
        const randomNumber = Math.floor(Math.random() * 9);
        if (randomChoices.indexOf(randomNumber) === -1) {
          randomChoices.push(randomNumber);
        } else {
          i -= 1;
        }
      }
    }
  }
  randomChoices = this.shuffle(randomChoices);
  return randomChoices;
};

IGP.shuffle = function (array) {
  let currentIndex = array.length;
  let temporaryValue;
  let randomIndex;
  while (currentIndex !== 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
};

IGP.checkAnswer = function (container) {
  if (container.isCorrect) {
    this.playCorrect();
    container.getData('markAnim').showMark(true, () => {});
    this.choices.map((x) => {
      x.disableInteractive();
      x.shakeAnim.stop();
      x.angle = 0;
      return true;
    });
    this.time.delayedCall(2000, this.nextIteration, [], this);
  } else {
    this.playWrong();
    container.shakeAnim.stop();
    container.angle = 0;
    container.disableInteractive();
    container.getData('markAnim').showMark(false, () => {});
  }
};

IGP.nextIteration = function () {
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.candy.destroy();
    this.candy = null;
    this.choices.map((x) => {
      x.destroy();
      return true;
    });
    this.choices = [];
    this.loadIteration();
  }
};

IGP.backToStart = function (choice) {
  choice.shakeAnim = this.tweens.add({
    targets: choice,
    angle: 0,
    duration: 100,
    ease: 'Sine.easeInOut',
    yoyo: false,
    onComplete: this.startShakeAnimation.bind(this, choice),
  });
};

IGP.startShakeAnimation = function (choice) {
  const repeats = 5;
  choice.shakeAnim = this.tweens.add({
    targets: choice,
    angle: 0,
    duration: 1,
    ease: 'Linear',
    yoyo: false,
    delay: 6000,
    onActive: this.moveRight.bind(this, choice, repeats),
  });
};

IGP.moveRight = function (choice, repeats) {
  repeats -= 1;
  if (repeats < 0) {
    this.backToStart(choice);
  } else {
    choice.shakeAnim = this.tweens.add({
      targets: choice,
      angle: 1,
      duration: 100,
      ease: 'Sine.easeInOut',
      yoyo: false,
      onComplete: this.moveLeft.bind(this, choice, repeats),
    });
  }
};

IGP.moveLeft = function (choice, repeats) {
  choice.shakeAnim = this.tweens.add({
    targets: choice,
    angle: -1,
    duration: 100,
    ease: 'Sine.easeInOut',
    yoyo: false,
    onComplete: this.moveRight.bind(this, choice, repeats),
  });
};

IGP.spriteAnimation = function (sprite) {
  const randomDelay = 5000 + Math.round(Math.random() * 4000);
  sprite.scaleAnim = this.tweens.add({
    targets: sprite,
    scaleX: 1.2,
    scaleY: 1.2,
    ease: 'Sine.easeInOut',
    duration: 500,
    delay: randomDelay,
    yoyo: true,
    onComplete: this.spriteAnimation.bind(this, sprite),
  });
};

export default EDC.Games.IdentifyGridPositions.Scenes.Main;
